module.exports = __webpack_public_path__ + "static/noticias-13-8edcaa542ba57dd1d0ce983a63a643f9.png";